import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelEsimSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelEsimSettingsEntity
